import { render, staticRenderFns } from "./AreaNameDialog.vue?vue&type=template&id=5d0e541b&scoped=true&"
import script from "./AreaNameDialog.vue?vue&type=script&lang=js&"
export * from "./AreaNameDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0e541b",
  null
  
)

export default component.exports